import { useState } from "react";
import PageTitle from "../../../components/PageTitle";
import Password from "../components/Password";
import styles from "../settings.module.css";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { Grid } from "@mui/material";
import { useUserState } from "../../../context/UserContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { httprequest } from "../../../data/api";

const Settings = () => {
  const [closeAccountModal, setCloseAccountModal] = useState(false);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [otherReason, setOtherReason] = useState("");
  const { userRole } = useUserState();
  const navigate = useNavigate();

  const closeReasons = [
    "No longer associated with the school",
    "Platform is difficult to use",
    "My child left the school",
    "Switching to a different school management platform",
    "Duplicate account"
  ];

  const handleReasonChange = (reason) => {
    setSelectedReasons((prev) => prev.includes(reason)
      ? prev.filter((r) => r !== reason)
      : [...prev, reason]
    );
  };

  const handleCloseAccountModal = () => {
    setCloseAccountModal(!closeAccountModal);
    if (closeAccountModal) {
      setSelectedReasons([]);
      setOtherReason("");
    }
  };
  const handleCloseAccount = async () => {
    try {
      const reasons = [...selectedReasons];

      if (otherReason.trim()) {
        reasons.push(otherReason.trim());
      }

      // Validation for both roles
      if (reasons.length === 0) {
        toast.error("Please select at least one reason for closing your account");

        return;
      }

      const requestData = {
        reasons
      };

      const response = await httprequest.delete("/api/v1/school/delete-account", {
        data: requestData
      });

      toast.success(response.data.message || "Account closed successfully");
      setCloseAccountModal(false);
      localStorage.removeItem("shelf21-auth");
      setSelectedReasons([]);
      setOtherReason("");

      setTimeout(() => {
        navigate("/auth/login");
      }, 1500);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to close account");
    }
  };

  const handleOtherReasonChange = (e) => {
    setOtherReason(e.target.value);
  };

  // Only show button for employee role
  return (
    <div>
      <PageTitle
        title="Settings"
        subtitle="You can make changes to your organisation's account."
        button={
          userRole?.role === "employee" && (
            <Button
              variant="dangeroutline"
              buttonSize="fluid"
              color="btndanger"
              buttonName="Close Account"
              onClick={handleCloseAccountModal}
            />
          )
        }
      />
      <div className={styles.pagecontent}>
        <Password />
      </div>

      <Modal
        title="Are you sure you want to close your account?"
        subtitle="Your account will be permanently deleted. This action cannot be undone."
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              {closeReasons.map((reason) => (
                <Grid item xs={12} key={reason}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      cursor: "pointer"
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedReasons.includes(reason)}
                      onChange={() => handleReasonChange(reason)}
                    />
                    <span>{reason}</span>
                  </label>
                </Grid>
              ))}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextAreaGroup
                  label="Other (Optional)"
                  inputName="comment"
                  margin="normal"
                  placeholder="Enter your reason"
                  value={otherReason}
                  onChange={handleOtherReasonChange}
                />
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <div style={{ display: "flex", gap: "10px", width: "100%" }}>
            <Button
              variant="primaryoutline"
              buttonSize="full"
              color="btnfontprimary"
              buttonName="Cancel"
              onClick={handleCloseAccountModal}
            />
            <Button
              type="submit"
              variant="danger"
              buttonName="Close Account"
              buttonSize="full"
              color="btndefault"
              onClick={handleCloseAccount}
            />
          </div>
        }
        isopen={closeAccountModal}
        closeModal={handleCloseAccountModal}
      />
    </div>
  );
};

export default Settings;
